export enum UploadExcelMessages {
  EMPTY_SHEET = "A planilha do Excel está vazia.",
  DIVERGENT_COLS = "Algumas colunas estão divergentes.",
  CELLS_WITH_ERROR = "Algumas células no corpo do Excel estão com erros.",
  HEADER_NOT_FIRST_LINE = "O cabeçalho da planilha não está na primeira linha.",
}

export type ExcelColumnError<T = [string]> = {
  columns: T;
  line: number;
  [key: string]: any;
};

export type DuplicateLineInExcel = {
  duplicate_fields: Array<string | number>;
  duplicates:
    | [
        { contract: Record<string, string | number | boolean>; line: number },
        { contract: Record<string, string | number | boolean>; line: number }
      ]
    | [
        { subgroup: Record<string, string | number | boolean>; line: number },
        { subgroup: Record<string, string | number | boolean>; line: number }
      ]
    | [
        { index: Record<string, string | number | boolean>; line: number },
        { index: Record<string, string | number | boolean>; line: number }
      ];
};
export type MaximumColumnSize = ExcelColumnError<
  { column: string; character_limit: number }[]
>[];
export interface ExcelCellsWithError {
  columns_not_float?: ExcelColumnError[];
  columns_not_integer?: ExcelColumnError[];
  columns_not_si_or_no?: ExcelColumnError[];
  empty_cells?: ExcelColumnError[];
  invalid_email_format?: ExcelColumnError[];
  subgroups_not_found?: ExcelColumnError[];
  contract_already_exists?: ExcelColumnError[];
  invalid_date_format?: ExcelColumnError[];
  maximum_column_size_exceeded?: MaximumColumnSize;
  duplicate_line_in_excel?: Array<DuplicateLineInExcel>;
  column_value_too_low?: ExcelColumnError[];
  invalid_risk_type?: ExcelColumnError[];
  cells_not_integer?: ExcelColumnError[];
  cells_not_float?: ExcelColumnError[];
  cells_negative?: ExcelColumnError[];
  cells_not_sim_nao?: ExcelColumnError[];
  repeated_names?: Array<ExcelColumnError & { lines: number[]; name: string }>;
  subgroup_code_size?: ExcelColumnError[];
  // Subgrupo
  repeated_subgroup?: Array<DuplicateLineInExcel>;
  rc_invalid_status_value?: Array<
    ExcelColumnError & { invalid_value?: string }
  >;
  rc_not_applicable?: Array<ExcelColumnError & { rc_not_applicable?: string }>;
  empty_fields?: ExcelColumnError[];
}

export interface ExcelHeaderErrors {
  "As colunas devem ser ordenadas da seguinte maneira:"?: string;
  "Coluna(s) não permitidas ou com nomenclatura errada"?: string;
  "Coluna(s) que faltaram"?: string;
}

export interface UploadExcelErrors {
  data_errors: ExcelCellsWithError;
  header_errors: ExcelHeaderErrors;
  message: UploadExcelMessages | string;
  success: boolean;
}

export const operationalApi = {
  async uploadExcel(excel: File) {
    const formData = new FormData();
    formData.append("excel", excel);

    return useNuxtApp().$api.post<{ token?: string }>(
      `/operator/contracts/read_contract_data_from_excel`,
      formData
    );
  },
};
